import React from 'react';
import Icon from '../../../components/AppIcon';

const AutoSaveIndicator = ({ status, lastSavedAt }) => {
  const formatTime = (date) => {
    if (!date) return null;
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    if (diff < 5) return 'just now';
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    return date?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  if (status === 'saving') {
    return (
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <div className="w-3 h-3 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <span>Saving draft...</span>
      </div>
    );
  }

  if (status === 'saved') {
    return (
      <div className="flex items-center gap-1.5 text-xs text-success">
        <Icon name="CheckCircle2" size={14} />
        <span>Draft saved {formatTime(lastSavedAt)}</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center gap-1.5 text-xs text-destructive">
        <Icon name="AlertCircle" size={14} />
        <span>Save failed — retrying</span>
      </div>
    );
  }

  if (status === 'unsaved') {
    return (
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <div className="w-2 h-2 rounded-full bg-warning" />
        <span>Unsaved changes</span>
      </div>
    );
  }

  return null;
};

export default AutoSaveIndicator;
